export default "__VITE_ASSET__CWHW073b__"